import { render } from "./VectorComp.vue?vue&type=template&id=298c02ca&scoped=true"
import script from "./VectorComp.vue?vue&type=script&lang=js"
export * from "./VectorComp.vue?vue&type=script&lang=js"

import "./VectorComp.vue?vue&type=style&index=0&id=298c02ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-298c02ca"]])

export default __exports__